import React, { lazy, memo, useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { apiGetRecaptchaConfiguration } from 'src/api/configuration';
import { UiModal } from 'src/components/UI/modal/UiModal';
import { signInOutSelector } from 'src/pages/Account/Profile/Signin/store/selectors';
import { signInOutSlice } from 'src/pages/Account/Profile/Signin/store/slice';
import styles from 'src/styles/pages/_signin.module.scss';
import { useOneRequest } from 'src/utils/hooks/useOneRequest';

const SignIn = lazy(() => import('src/pages/Account/Profile/Signin'));

declare global {
  interface Window {
    showLoginModal: (v: boolean) => void; // show login modal from anywhere
  }
}

export const AnywhereLoginModal: React.FC = memo(() => {
  const dispatch = useDispatch();

  const [permanentUrl, setPermanentUrl] = useState<string | undefined>(undefined);
  const [recaptchaSiteKey, setRecaptchaSiteKey] = useState<string | undefined>(undefined);

  const { apiCaller, loading } = useOneRequest(apiGetRecaptchaConfiguration, { showErrors: false });

  useEffect(() => {
    window.spa.showLoginModal = (show = true, permanentUrl = undefined) => {
      if (permanentUrl) {
        setPermanentUrl(permanentUrl);

        apiCaller({ PermanentUrl: permanentUrl }).then((response) => {
          setRecaptchaSiteKey(response.SiteKey);
        });
      }

      dispatch(signInOutSlice.actions.changeModal(show));
    };
  }, [apiCaller, dispatch]);

  const { modal } = useSelector(signInOutSelector);

  const onHide = useCallback(() => {
    setPermanentUrl(undefined);
    setRecaptchaSiteKey(undefined);
    dispatch(signInOutSlice.actions.changeModal(false));
  }, [dispatch]);

  return modal ? (
    <UiModal modalClassName={styles.signInModal} noFooter onHide={onHide} loading={loading}>
      {!loading && <SignIn permanentUrl={permanentUrl} recaptchaSiteKey={recaptchaSiteKey} />}
    </UiModal>
  ) : null;
});
